<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" id="labelButtons">Contact Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="contactForm" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required">Contact Type</label>
                    <select class="mvd_form-control" (change)="updateComponentForContactType()" formControlName="contactMethodTypeId">
                        <option [ngValue]="contact.id" *ngFor="let contact of customerContactTypes">{{ contact.displayValue }}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="contactForm.get('contactMethodTypeId').hasError('required') && !contactForm.get('contactMethodTypeId').pristine">Contact type is required</div>
                    </div>
                </div>
                <div class="col-sm-7 mvd_form-group">
                    <label>Contact Value</label>
                    <input class="mvd_form-control" type="text" formControlName="customerContactValue" />
                </div>
                <div class="col-sm-1 mvd_form-group" *ngIf="contactId != 0">
                    <label>&nbsp;</label>
                    <a class="icon--delete" title="Delete Contact" href="javascript:void(0)" (click)="deleteContact()"></a>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2 mvd_form-group" *ngIf="isMobile || isEmail">
                    <label *ngIf="isMobile">Text Enabled</label>
                    <label *ngIf="isEmail">Email Enabled</label>
                    <input type="checkbox" formControlName="isCorrespondenceEnabled" />
                </div>
                <div class="col-sm-2 mvd_form-group" *ngIf="isPhone || isEmail">
                    <label>Primary</label>
                    <input type="checkbox" formControlName="isPrimary" />
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group" *ngIf="isEmail">
                    <label>Preferred Contact Method</label>
                    <input type="checkbox" formControlName="isPreferredContactMethod" />
                </div>
                <div class="col-sm-3 mvd_form-group" *ngIf="isEmail || isPhone || isFax">
                    <label *ngIf="isEmail">Undeliverable</label>
                    <label *ngIf="isPhone || isFax">Unreachable</label>
                    <input type="checkbox" (change)="invalidChanged($event)" formControlName="isInvalid" />
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(contactForm.valid && contactForm.dirty)" [isLoading]="showButtonLoading" btnText="Save" (clicked)="saveContact()"></mvm-spinner-btn>
    </div>
</div>